import { createSelector } from 'reselect';
const getOnboardingSettings = state => {
  return state.onboardingSettings;
};
export const getHasPortalSeenActivationModal = createSelector([getOnboardingSettings], onboardingSettings => {
  return onboardingSettings.hasSeenPortalFmoOnboarding;
});